import { IContact } from 'types';

export const createContactArray = (contact?: IContact): string[] => {
  if (!contact) {
    return [];
  }

  const {
    firstName,
    lastName,
    contactNumber,
    email,
    jobTitle,
    jobOther,
  } = contact;

  const contactArray = [];
  contactArray.push(`${firstName} ${lastName}`);
  contactArray.push(email);
  contactArray.push(contactNumber);

  if (jobOther) {
    contactArray.push(jobOther);
  } else {
    contactArray.push(jobTitle);
  }

  return contactArray;
};
